// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button } from '@tapsioss/react-components/Button';
import style from './FeatureStyles.module.scss';
import Features from './Features';
import { TEST_IDS } from 'common/testId.ts';
import { Switch } from '@tapsioss/react-components/Switch';
import Drawer from 'src/common/components/Drawer';
import { Row } from 'src/common/components/Flex';

export type Feature = {
  key: string;
  defVal: boolean;
};

export type ConfigFeaturesProps = {
  appFeatures: Features;
};

const ConfigFeatures: React.FC<ConfigFeaturesProps> = ({ appFeatures }) => {
  const [open, setOpen] = useState(false);
  const [featuresData, setFeaturesData] = useState<Record<string, boolean>>({});

  useEffect(() => {
    setFeaturesData(appFeatures.getFormattedFeatures());
  }, [appFeatures]);

  const updateFeatures = (selectedFeature: string, checkedValue: boolean) => {
    setFeaturesData((prevState) => ({
      ...prevState,
      [selectedFeature]: checkedValue,
    }));
  };

  const getRenderSwitch = ({ featureKey, featureValue }) => (
    <Switch
      label=""
      aria-label={featureKey}
      selected={featureValue}
      value={featureKey}
      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        updateFeatures(featureKey, !featureValue);
      }}
      disabled={false}
    />
  );

  return (
    <div className={style.features}>
      <Button className={style.button} onClick={() => setOpen(true)} data-testid={TEST_IDS.toghol.featuresButton}>
        Features
      </Button>
      <Drawer
        classes={{ root: style.drawer, paper: style.drawerAnchor }}
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        style={{ overflow: 'hidden' }}
      >
        <div className={style.drawerContent}>
          <div className={style.featureList}>
            {Object.keys(featuresData).length > 0 &&
              Object.entries(featuresData).map(([featureKey, featureValue]) => (
                <Row
                  key={featureKey}
                  dir="rtl"
                  className={style.featureItem}
                  align="center"
                  data-testid={TEST_IDS.toghol.featureItem}
                >
                  {getRenderSwitch({ featureKey, featureValue })}
                  <p className={style.featureLabel}>{featureKey}</p>
                </Row>
              ))}
          </div>
          <div className={style.action}>
            <Button
              onClick={() => {
                appFeatures.saveFeatures(featuresData);
                document.location.reload();
                return false;
              }}
              data-testid={TEST_IDS.toghol.submitFeature}
              variant="primary"
              size="lg"
            >
              Apply Changes
            </Button>
            <Button size="lg" variant="ghost" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default ConfigFeatures;
